// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MedicineBoxOutlinedSvg from "@ant-design/icons-svg/es/asn/MedicineBoxOutlined";
import AntdIcon from '../components/AntdIcon';

var MedicineBoxOutlined = function MedicineBoxOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MedicineBoxOutlinedSvg
  }));
};

MedicineBoxOutlined.displayName = 'MedicineBoxOutlined';
export default React.forwardRef(MedicineBoxOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MedicineBoxOutlined.js
// module id = 1455
// module chunks = 0